import React from 'react';

import AuthCard from 'ui-brand/components/AuthCard';
import Button from 'ui-brand/components/Button';

type Props = {
  onRetry?: () => void;
};

function ErrorStep({ onRetry = () => window.location.reload() }: Props) {
  return (
    <AuthCard
      title={gettext('Something went wrong')}
      subtitle={gettext(
        'Please start from the beginning and try again. If the error prevails, please contact our support and we will help you.',
      )}
    >
      <div className="mt-8 flex flex-col items-center gap-4">
        <Button variant="primary" size="lg" fullWidth onClick={onRetry}>
          {gettext('Try again')}
        </Button>
        <a href="mailto:support@retino.com" className="text-sm font-semibold text-brand-500">
          support@retino.com
        </a>
      </div>
    </AuthCard>
  );
}

export default ErrorStep;
